import React from 'react'
import css from './Experience.module.css'
import { UserContext } from '../UseContext'
import { motion } from "framer-motion";
import { fadeIn, slideIn, staggerContainer } from "../utils/motion";
import companyLogo from '../assets/experience/main-logo.svg'
import headerVariants from '../utils/motion'
function Experience() {
  return (
    <>
    <a className="position_atag" id='experience'></a>
  
    <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.25 }}
        // className={`innerWidth ${css.container}`}
        className={css.expbg}
      >
    {/* <div className={css.leftdiv}> */}
<p>Experience</p>
{/* <motion.div className={css.centerdiv} variants={fadeIn("headerVariants", "tween", 0.2, 1)}> */}

          <motion.div className={css.centerdiv} variants={fadeIn("down", "tween", 0.2, 1)}>

<div className={css.tablediv}>
    <div className={css.tabledivleft}>
<img src={companyLogo}/>
    </div>
    <div className={css.tabledivright}>

<div>
<p><b>Role : </b>Frontend developer - Intern</p>
<p>24 July 2023 - 23 October 2023 <b>: Intern Period</b></p>
</div>
<div>
<p><b>Company : </b>CodeParva Technologies Pvt. Ltd.</p>
{/* <p>  JP Nagar 7th Phase, Bengaluru, Karnataka 560078</p> */}
<p>Angular | React | Netlify | Git <b>: Skills Gained</b></p>



</div>
       <p>
The company is working in the self-storage industry.
My role is working on frontend. They assign a case, and as per the case's I worked on, it was like the payment page, storage sizes, API issues, content change, image change, and all the frontend issues.

       </p>

     <button className={css.input}>
     <a   href='https://drive.google.com/file/d/1BcmNKutgvZ-bmCs_xQkSIr2c-ykG5rhT/view' target='_blank'
       >Completion Certificate</a> 
     </button>
        </div>
</div>

</motion.div>

</motion.div>    
    </>
  )
}

export default Experience